import { render, staticRenderFns } from "./userReal.vue?vue&type=template&id=d906b860&scoped=true&"
import script from "./userReal.vue?vue&type=script&lang=js&"
export * from "./userReal.vue?vue&type=script&lang=js&"
import style0 from "./userReal.vue?vue&type=style&index=0&id=d906b860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d906b860",
  null
  
)

export default component.exports